exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyable-field[data-v-00684a1a]{display:block;min-width:0}.copyable-field__text[data-v-00684a1a]{color:#303133;word-break:break-all}.copyable-field__text--copyable[data-v-00684a1a]{cursor:pointer;user-select:none;-webkit-user-select:none;-ms-user-select:none}.copyable-field__text--copyable[data-v-00684a1a]::selection{background:transparent}.copyable-field__text--copyable[data-v-00684a1a]::-moz-selection{background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00684a1a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CopyableField.vue
// module id = r+BC
// module chunks = 0